import { formatBuilt, hardRefresh, updateStore, useUpdate } from './version';

/** Bottom-centre chip shown once a newer build is on the server; reload when convenient. */
export function UpdateNotice() {
  const available = useUpdate((s) => s.available);
  const dismissed = useUpdate((s) => s.dismissed);
  if (!available || dismissed) return null;
  return (
    <div className="update-notice" role="status">
      <span>
        New version available <span className="muted">(built {formatBuilt(available.built)})</span>
      </span>
      <button type="button" className="btn btn-primary" onClick={() => void hardRefresh()}>
        Reload
      </button>
      <button type="button" className="btn" onClick={() => updateStore.setState({ dismissed: true })}>
        Later
      </button>
    </div>
  );
}
